module.exports = __webpack_public_path__ + "static/media/HT.dbe5157c.png";